<template>
  <div class="poc-upload-video-page">
    <h1>Video Upload POC - V-20251101-16.24</h1>
    <ChunkedVideoUploader />
  </div>
</template>

<script>
import ChunkedVideoUploader from "@/components/ChunkedVideoUploader.vue";

export default {
  name: "PocUploadVideo",
  components: {
    ChunkedVideoUploader,
  },
};
</script>

<style scoped>
.poc-upload-video-page {
  padding: 20px;
  text-align: center;
}

h1 {
  margin-bottom: 30px;
  color: #333;
}
</style>
